import React from 'react';
import { AppButton, AppModal, Flex } from '../common';
import { useOldView } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface ChooseSystemModalProps {
  open?: boolean;
  hide: () => void;
  data: { url: string };
}

const ChooseSystemModal: React.FC<ChooseSystemModalProps> = ({
  hide,
  open = false,
  data
}) => {

  const navigate = useNavigate();
  const [t] = useTranslation(['common']);
  const { toOldView, loading } = useOldView();

  const handleNewVersion = () => {
    navigate(data.url, { replace: true });
    hide();
  };

  return (
    <AppModal
      destroyOnHidden
      width="90%"
      onCancel={hide}
      variant="glass"
      open={open}
      style={{ maxWidth: '700px' }}
      title={t('common:messages.welcome')}
      footer={null}
    >
      <Flex direction="column">
        <p>
          {t('common:messages.login-modal')}
        </p>
        <AppButton onClick={handleNewVersion} appVariant="nurture">
          {t('common:messages.login-student')}
        </AppButton>
        <AppButton onClick={toOldView} appVariant="submit" loading={loading}>
          {t('common:messages.login-management')}
        </AppButton>
      </Flex>
    </AppModal>
  );
};

export default ChooseSystemModal;
